import { components } from 'gridstrap/lib/gs-components';
import { GSData } from './data';
import { GSDataService } from './data-service';

components.register({
	selector: '.gs-Data',
	controller: GSData
});

export const data = new GSDataService();
